import angular from 'angular';
import { artistService } from './artistService';
import { bitUrlBuilderModule } from '../bitUrlBuilder/bitUrlBuilder.module';
import angularCache from 'angular-cache';

export const artistServiceModule = angular
  .module('bit.services.artistService', [
    bitUrlBuilderModule.name,
    angularCache,
  ])
  .factory('artistService', artistService);
